var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { shiftParticipantEntityName } from '../../../../backend/features/shift/shared';
import { approveHoursDialog } from '../../../../ui/features/shift-roster-table/utils/approveHoursDialog';
import { useShiftParticipantActions } from '../../../../ui/features/shift/hooks/useShiftParticipantActions';
import { useMissionsTranslation, useShiftParticipantStorage } from '../../../../ui/hooks';
import { beginExport } from '@juvare/platform-sdk-react/ui/components/EntityTable/entityExport';
import { useExportClient } from '@juvare/platform-sdk-react/ui/hooks';
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import FileDownloadOutlined from '@mui/icons-material/FileDownloadOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import SendIcon from '@mui/icons-material/Send';
import React from 'react';
import { useShiftParticipantImport } from '../../shift-roster-table/hooks/useShiftParticipantImport';
export function useShiftParticipantsTableActions({ onSendMessageToVolunteers, fetchReload, onAddVolunteers, missionStatus, totalApprovedRequests, numberOfRequiredParticipants, selected, selectedIds, shiftId, }) {
    const { t } = useMissionsTranslation();
    const shiftParticipantStorage = useShiftParticipantStorage();
    const exportClient = useExportClient();
    const { importShiftParticipants } = useShiftParticipantImport();
    const { handleApproveHours } = useShiftParticipantActions();
    const isShiftFull = totalApprovedRequests >= numberOfRequiredParticipants;
    const isMissionDraft = missionStatus === 'draft';
    const allowApproveHours = selected.some((selectedParticipant) => selectedParticipant.hoursStatus === 'pending');
    const getSelectedRows = () => __awaiter(this, void 0, void 0, function* () {
        return (yield shiftParticipantStorage.list({
            filter: [
                {
                    op: 'in',
                    id: selectedIds,
                },
            ],
        })).rows;
    });
    const handleExportHours = () => {
        const filter = [
            {
                column: 'shiftId',
                op: '=',
                value: shiftId,
            },
            { column: 'status', op: '=', value: 'approved' },
        ];
        const orderBy = [{ column: 'participantFullName' }];
        beginExport(exportClient, shiftParticipantEntityName, 'csv', selectedIds.length > 0 ? selectedIds : undefined, filter, orderBy);
    };
    const handleShiftParticipantImport = React.useCallback(() => {
        importShiftParticipants({ onAfterImport: fetchReload, shiftId });
    }, [fetchReload, importShiftParticipants, shiftId]);
    const actions = [
        {
            icon: React.createElement(FileDownloadOutlined, null),
            label: t('shifts.adminTimeTracking.importHours'),
            variant: 'text',
            onClick: handleShiftParticipantImport,
            disabled: isMissionDraft,
        },
        {
            icon: React.createElement(FileUploadOutlinedIcon, null),
            label: t('shifts.adminTimeTracking.exportHours'),
            disabled: !totalApprovedRequests,
            variant: 'text',
            onClick: handleExportHours,
        },
        {
            icon: React.createElement(AddIcon, null),
            label: t('shifts.addVolunteers'),
            disabled: isMissionDraft || isShiftFull,
            variant: 'text',
            onClick: onAddVolunteers,
            'data-test': 'add-volunteers-button',
        },
        ...(onSendMessageToVolunteers
            ? [
                {
                    icon: React.createElement(SendIcon, null),
                    label: t('missions.missionDetails.sendMessage'),
                    disabled: !selected || selected.length === 0,
                    onClick: () => onSendMessageToVolunteers(selectedIds),
                    'data-test': 'send-message-button',
                },
            ]
            : []),
        {
            icon: React.createElement(CheckIcon, null),
            label: t('shifts.adminTimeTracking.approveHours'),
            disabled: !allowApproveHours,
            onClick: () => __awaiter(this, void 0, void 0, function* () {
                return approveHoursDialog({
                    rows: yield getSelectedRows(),
                    handleApproveHours,
                    t,
                    fetchReload: () => __awaiter(this, void 0, void 0, function* () {
                        return fetchReload();
                    }),
                });
            }),
            'data-test': 'approve-hours-button',
        },
    ];
    return actions;
}
